import { queryGraph } from "@/lib/bear-sandbox-bridge";

/**
 * The nodes behind a 3D selection. The inspector and the part menu both read
 * them, and share one query rather than each asking the sandbox.
 */
export function selectedNodesQuery(nodeIds: string[]) {
  return {
    queryKey: ["selected-nodes", nodeIds],
    queryFn: () => queryGraph([["nodes", ...nodeIds]]),
    enabled: nodeIds.length > 0,
  };
}
